export const DESIGN_MODE_BLANK_THREAD_ID = 'thread-design-mode-blank'

const DEMO_NOW = 1_748_630_000_000

/** @returns {{ thread: object, messages: object[] }} */
export function buildDesignModeBlankSeed() {
  return {
    thread: {
      id: DESIGN_MODE_BLANK_THREAD_ID,
      title: 'Design System',
      createdAt: DEMO_NOW,
      updatedAt: DEMO_NOW,
    },
    messages: [],
  }
}
